import { Button, Form, Select, Typography } from 'antd'
import { InspectionArea } from 'features/libra/inspectionPlanning/planningTypes'
import {
  MethodAssignment,
  TechniqueCatalogue,
} from 'features/libra/inspectionPlanning/techniqueTypes'
import { ZoneParams } from 'features/libra/stepComponents/zoneAnalysis/zoneAnalysisApi'
import { useState } from 'react'

import { ExecutionRow } from './executionTypes'

export const ExecutionScopeSelector = ({
  zones,
  areas,
  catalogue,
  rows,
  allowRepeated,
  onAdd,
}: {
  zones: ZoneParams[]
  areas: InspectionArea[]
  catalogue: TechniqueCatalogue
  rows: ExecutionRow[]
  allowRepeated: boolean
  onAdd: (
    zone: ZoneParams,
    area: InspectionArea,
    methods: MethodAssignment[]
  ) => void
}) => {
  const [zoneId, setZoneId] = useState<string>()
  const [areaId, setAreaId] = useState<string>()
  const [methodIds, setMethodIds] = useState<string[]>([])
  const zone = zones.find((item) => item.id === zoneId)
  const zoneAreas = areas.filter((item) => item.sourceZoneId === zoneId)
  const area = zoneAreas.find((item) => item.id === areaId)
  const methods = area
    ? area.methodAssignments.filter(
        (method) =>
          allowRepeated ||
          !rows.some(
            (row) =>
              row.inspectionAreaId === area.id &&
              row.methodAssignmentId === method.id
          )
      )
    : []
  const selected = methods.filter((method) => methodIds.includes(method.id))
  const changeZone = (id: string) => {
    setZoneId(id)
    const choices = areas.filter((item) => item.sourceZoneId === id)
    setAreaId(choices.length === 1 ? choices[0].id : undefined)
    setMethodIds([])
  }
  const changeArea = (id: string) => {
    setAreaId(id)
    setMethodIds([])
  }
  const add = () => {
    if (!zone || !area || !selected.length) return
    onAdd(zone, area, selected)
    setMethodIds([])
  }
  return (
    <Form layout='vertical' component='div'>
      <Form.Item label='Zone'>
        <Select
          aria-label='Zone'
          value={zoneId}
          onChange={changeZone}
          options={zones.map((item) => ({ value: item.id, label: item.title }))}
        />
      </Form.Item>
      <Form.Item label='Inspection area / full-zone scope'>
        <Select
          aria-label='Inspection area / full-zone scope'
          value={areaId}
          disabled={!zone}
          onChange={changeArea}
          options={zoneAreas.map((item) => ({
            value: item.id,
            label:
              item.scope === 'zone' ? `${item.title} · Full zone` : item.title,
          }))}
        />
      </Form.Item>
      <Form.Item label='Methods'>
        <Select
          aria-label='Methods'
          mode='multiple'
          value={methodIds}
          disabled={!area}
          onChange={setMethodIds}
          options={methods.map((method) => ({
            value: method.id,
            label: resolveMethodAssignment(method, catalogue).method,
          }))}
        />
      </Form.Item>
      {zone && !zoneAreas.length && (
        <Typography.Paragraph type='secondary'>
          Define this zone’s inspection scope and methods in the planning step
          first.
        </Typography.Paragraph>
      )}
      <Button onClick={add} disabled={!selected.length}>
        Add selected methods
      </Button>
    </Form>
  )
}
import { resolveMethodAssignment } from 'features/libra/inspectionPlanning/methodAssignments'
